import { render, staticRenderFns } from "./ModalService.vue?vue&type=template&id=0f4c54ae&scoped=true"
import script from "./ModalService.vue?vue&type=script&lang=js"
export * from "./ModalService.vue?vue&type=script&lang=js"
import style0 from "./ModalService.vue?vue&type=style&index=0&id=0f4c54ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c54ae",
  null
  
)

export default component.exports